import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, BookOpen } from "lucide-react";
import { Button } from "./ui/button";

const FinalCTA = () => {
  return (
    <section className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="bg-[#111827] rounded-2xl px-8 py-12 text-center relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-indigo-600/10 to-transparent" />
        <div className="relative">
          <h2 className="text-2xl sm:text-3xl font-extrabold text-white mb-3">Compare the published evidence register</h2>
          <p className="text-slate-300 text-sm mb-8">Review all 55 criterion records, cited vendor material and unverified gaps without an invented winner.</p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            <Link to="/ecommerce-comparisons" data-testid="final-comparisons-link">
              <Button className="bg-indigo-500 hover:bg-indigo-600 rounded-lg h-11 px-6">
                Compare Evidence <ArrowRight className="w-4 h-4 ml-1.5" />
              </Button>
            </Link>
            <Link to="/methodology" data-testid="final-methodology-link">
              <Button variant="outline" className="bg-transparent border-white/25 text-white hover:bg-white/10 hover:text-white rounded-lg h-11 px-6">
                <BookOpen className="w-4 h-4 mr-1.5" /> Read Our Methodology
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
